'use client';

import { useState } from 'react';
import { Box, Stack } from '@/primitives';
import { useMediaQuery, Theme, Menu, MenuItem } from '@mui/material';
import { GridPreferencePanelsValue } from '@mui/x-data-grid-pro';
import PublicSearchInput from '@/components/publicSearch/searchSection/PublicSearchInput';
import SearchDisplayTypeSelection from '@/components/publicSearch/searchSection/SearchDisplayTypeSelection';
import SearchActions, { StyledSearchIconButton } from './SearchActions';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { searchApiRef } from '../searchSection/PublicSearchDataGrid';

interface SearchHeaderProps {
  isMobile: boolean;
  resultDisplay: any;
  setResultDisplay: (value: any) => void;
  resetColumnDisplay: () => void;
}

export default function SearchHeader({
  isMobile,
  resultDisplay,
  setResultDisplay,
  resetColumnDisplay,
}: SearchHeaderProps) {
  const isSmallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const openMenu = Boolean(anchorEl);

  function handleClickManageColumns() {
    handleMenuClose();
    searchApiRef.current?.showPreferences(GridPreferencePanelsValue.columns);
  }

  function handleClickResetLayout() {
    handleMenuClose();
    resetColumnDisplay();
  }

  return (
    <Box sx={{ px: 2, py: isMobile ? 0 : 2 }}>
      <Stack
        direction={isSmallScreen ? 'column' : 'row'}
        spacing={2}
        alignItems={'center'}
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent={'space-between'}
          sx={{ flexGrow: 1, width: isSmallScreen ? '100%' : 'auto' }}
        >
          <SearchDisplayTypeSelection
            isMobile={isMobile}
            resultDisplay={resultDisplay}
            setResultDisplay={setResultDisplay}
          />
          <StyledSearchIconButton color="primary" onClick={handleMenuClick}>
            <SettingsOutlinedIcon />
          </StyledSearchIconButton>
          <Menu
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <MenuItem onClick={handleClickManageColumns}>
              Manage columns
            </MenuItem>
            <MenuItem onClick={handleClickResetLayout}>Reset Layout</MenuItem>
          </Menu>
          {!isSmallScreen && <PublicSearchInput />}
          <SearchActions />
        </Stack>
        {isSmallScreen && <PublicSearchInput />}
      </Stack>
    </Box>
  );
}
